const setIds = (state, ids) => {
  state.ids = ids;
};

const setCurrent = (state, accountId) => {
  state.current = accountId;
};

const setMeta = (state, meta) => {
  state.meta = meta;
};

const setLinks = (state, links) => {
  state.links = links;
};

export default {
  setIds,
  setCurrent,
  setMeta,
  setLinks,
};
